import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class Queries {

  getPendencies(): DocumentNode {
    return gql`
      query paginatedPendencies (
        $where: PendenciesWhereInput,
        $orderBy: PendenciesOrderByInput,
        $after: String,
        $take: Int
      ) {
        pendencies(where: $where, orderBy: $orderBy, after: $after, take: $take) {
          totalCount
          pageInfo {
            startCursor
            endCursor
          }
          items {
            id
            title
            identifier
            createdAt
            updatedAt
            company {
              name
              avatarUrl
            }
            pendencyType {
              name
            }
            assignee {
              id
              name
              avatarUrl
            }
            treatmentStatus
            status
            archived
          }
        }
      }
    `;
  }
}
